module.exports = __webpack_public_path__ + "static/media/HU.cd886841.png";